export class Preview_Adherence {
	savePostData( post ) {
		this.post = post;
		this.sendDataToAPI();
	}

	sendDataToAPI() {
		var nonce = wpApiSettings.nonce;
		var data = { formData: this.post };

		$.ajax( {
			        type      : 'POST',
			        url       : wpApiSettings.root + 'isda/v1/protocol-adherence/',
			        beforeSend: function( xhr ) {
				        xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
				        $( '.letter-preview-wrapper' )
					        .html( ' <img class="preloader" src="' + ISDA_Main.ajaxLetterPreloader + '">' );
			        },
			        data      : data,
			        dataType  : 'json',
			        success   : function( result ) {
				        if ( 'undefined' !== typeof result.adherence_post_id && 0 !== parseInt( result.adherence_post_id ) ) {
					        let adherence_isda_id = parseInt( result.adherence_isda_id );
					        $( 'input[name=_adherence_post_id]' )
						        .val( result.adherence_post_id );
					        // removed as was causing issue with duplicate adherence_isda_id
					        //					        window.history.pushState( {}, '', `${$( '#selected-protocol' )
					        //						        .val()}${adherence_isda_id}/` );
				        }

				        if ( 'undefined' !== typeof result.letter ) {
					        $( '.letter-preview-wrapper' )
						        .html( result.letter );
				        }

				        if ( 'undefined' !== typeof result.letter ) {
					        $( 'html,body' ).scrollTop( 155 );
				        }

			        },
			        complete  : function( result ) {
				        // console.log(result);
			        }
		        } );
	}
}